/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import {
  FormControl,
  Icon,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Autocomplete,
  TextField,
  Box,
} from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataPaginateTable from "examples/Tables/DataPaginateTable";
import NotificationItem from "examples/Items/NotificationItem";

import { URL_API } from "config";

import MDInput from "components/MDInput";
import { makeStyles } from "@material-ui/core/styles";
import { useAuthContext } from "context/AuthContext";

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
      padding: "3px",
      width: 148,
    },
  },
}));

function FollowUpTable() {
  const [cooperateds, setCooperateds] = useState([]);

  const [rowSelected, setRowSelected] = useState();
  const [rowStatus, setRowStatus] = useState(false);

  const [loading, setLoading] = useState(false);

  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);

  const [companies, setCompanies] = useState([]);
  const [companyGuid, setCompanyGuid] = useState();
  const [status, setStatus] = useState(1);
  const [filter, setFilter] = useState();
  const classes = useStyles();

  const navigate = useNavigate();

  let tag = localStorage.getItem("Tag");

  const { user } = useAuthContext();

  const dataTableData = {
    columns: [
      { Header: "Criação", accessor: "created_at" },
      { Header: "Atualização", accessor: "updated_at" },
      { Header: "Nome", accessor: "full_name" },
      { Header: "Número Conta", accessor: "account_number" },
      { Header: "PA", accessor: "pa_number" },
      { Header: "Companhia", accessor: "company_name" },
      { Header: "CPF", accessor: "cpf" },
      { Header: "Telefone", accessor: "phone" },
      { Header: "Email", accessor: "email" },
      { Header: "StatusFollowUp", accessor: "status" },
      { Header: "UUID", accessor: "uuid" },
      { Header: "Ações", accessor: "action", width: "7%" },
      { accessor: "pa_id" },
    ],
    rows: cooperateds,
  };

  const stts = [
    { name: "Todos", id: 0 },
    { name: "Em Aberto", id: 1 },
    { name: "Iniciado", id: 2 },
    { name: "Em Análise", id: 3 },
    { name: "Pendência Documentos", id: 4 },
    { name: "Em Processo de Admissão", id: 5 },
    { name: "Aprovado", id: 6 },
    { name: "Reprovado", id: 7 },
    { name: "Aguardando Assinatura", id: 8 },
    { name: "Finalização Cadastral", id: 10 },
  ];

  useEffect(() => {
    if (user?.profile !== 99) navigate("/admin/dashboard");

    getCompanies();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);

      await getCooperateds(tablePage, tableLimit);

      setLoading(false);
    })();
  }, [companies, tablePage, tableLimit, rowStatus]);

  async function getCooperateds(page = 1, limit = 10) {
    await axios
      .get(
        URL_API +
          `/cooperateds?page=${page}&limit=${limit}` +
          `${filter ? `&filter=${filter}` : ""}` +
          `${status && filter ? `&status=${status}` : ""}` +
          `${status && !filter ? `&status=${status}` : ""}` +
          `${
            companyGuid && (filter || status)
              ? `&company_id=${companyGuid}`
              : ""
          }` +
          `${
            companyGuid && !status && !filter
              ? `&company_id=${companyGuid}`
              : ""
          }`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then((response) => {
        for (const coop of response?.data?.data) {
          let obj = companies.find((o) => o.uuid === coop.company_id);
          if (obj) coop.company_name = obj?.name;
        }

        for (const data of response?.data.data) {
          data.created_at = new Date(data.created_at).toLocaleDateString(
            "pt-BR"
          );
          data.updated_at = new Date(data.updated_at).toLocaleDateString(
            "pt-BR"
          );
        }

        setCooperateds(response?.data?.data);
        setTableTotal(response?.data.meta?.total);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function getCompanies() {
    await axios
      .get(URL_API + "/companies?page=1&limit=500", {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then((response) => {
        setCompanies(response.data.data);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        }
        toast.error(error?.response?.data?.message);
      });
  }

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox pt={2}>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Filtros para Colaboradores
                </MDTypography>
              </MDBox>
              <MDBox
                p={1}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid container>
                  <Autocomplete
                    className="textfield"
                    classes={classes}
                    sx={{ marginBottom: 1 }}
                    onChange={(_, value) => setCompanyGuid(value.uuid)}
                    getOptionLabel={(company) => company.name}
                    options={companies}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Buscar por companhias..."
                      />
                    )}
                  />

                  <MDBox p={1} />

                  <Grid item>
                    <MDInput
                      label="Buscar por colaborador..."
                      onChange={async (event) => setFilter(event.target.value)}
                      size="large"
                    />
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <FormControl sx={{ width: 190 }}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={status}
                        label="Status"
                        sx={{ height: "45px" }}
                        onChange={(value) => setStatus(value.target.value)}
                      >
                        {stts.map((s) => {
                          return <MenuItem value={s.id}>{s.name}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <IconButton
                      onClick={async () =>
                        await getCooperateds(tablePage, tableLimit)
                      }
                      sx={{
                        color: "#fff",
                        background: "#3f50b5",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "blue",
                        },
                      }}
                    >
                      <Icon>search</Icon>
                    </IconButton>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </Card>
          <MDBox pt={2}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Colaboradores
                </MDTypography>
              </MDBox>
              {loading ? (
                <Box sx={{ width: "100%" }}>
                  <LinearProgress sx={{ overflow: "hidden" }} />
                </Box>
              ) : (
                <DataPaginateTable
                  entriesPerPage={{ defaultValue: tableLimit }}
                  table={dataTableData}
                  onRowSelected={setRowSelected}
                  setTableLimit={setTableLimit}
                  tableLimit={tableLimit}
                  setTablePage={setTablePage}
                  tablePage={tablePage}
                  tableTotal={tableTotal}
                  rowStatus={rowStatus}
                  setRowStatus={setRowStatus}
                >
                  {[
                    <NotificationItem
                      onClick={() => {
                        navigate(
                          "/admin/cooperateds/update/" +
                            rowSelected.original.uuid
                        );
                      }}
                      icon={<Icon>create</Icon>}
                      title="Editar"
                    />,
                  ]}
                </DataPaginateTable>
              )}
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}

export default FollowUpTable;
